import { html } from 'lit';
const CopyAsImgae =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.75 5A2.25 2.25 0 0 1 5 2.75h9A2.25 2.25 0 0 1 16.25 5v2.75H19A2.25 2.25 0 0 1 21.25 10v9A2.25 2.25 0 0 1 19 21.25h-9A2.25 2.25 0 0 1 7.75 19v-2.75H5A2.25 2.25 0 0 1 2.75 14zm12 0v2.75H10A2.25 2.25 0 0 0 7.75 10v4.75H5a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 5 4.25h9a.75.75 0 0 1 .75.75m-5.5 12.81V19c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75v-2.69l-.97-.969a.75.75 0 0 0-1.06 0l-.66.659.97.97a.75.75 0 1 1-1.06 1.06l-1.5-1.5-1.94-1.939a.75.75 0 0 0-1.06 0zM16 14.94l-1.409-1.41a2.25 2.25 0 0 0-3.182 0L9.25 15.69V10a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v4.194a2.25 2.25 0 0 0-3.091.086zm-.15-2.74a.85.85 0 1 0 0-1.7.85.85 0 0 0 0 1.7" clip-rule="evenodd"/>
  </svg>
`;
export default CopyAsImgae;
